import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
// Styles are imported in App.tsx
import App from './App.tsx'

// Error monitoring — inert unless VITE_SENTRY_DSN is set at build time.
const sentryDsn: string = import.meta.env.VITE_SENTRY_DSN ?? ''
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    // Errors always; keep performance sampling light.
    tracesSampleRate: 0.1,
  })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
